import React from "react";
import { Modal } from "antd";
import { Layout } from "antd";
import ActivityForm from "./ActivityForm";
import AddActivityForm from "./AddActivityForm";

const AddActivityModal = ({
  Visible,
  isModalVisible,
  setModalVisible,
}: any) => {
  const handleOk = () => {
    Visible(false);
    setModalVisible(false);
  };
  return (
    <Layout>
      <Modal
        visible={isModalVisible}
        className="organization_model"
        onOk={handleOk}
        onCancel={() => {
          setModalVisible(false);
        }}
        centered={true}
        footer={null}
        width={600}
      >
        <div className="model-header">
          <h4>Add activity</h4>
        </div>
        <AddActivityForm />
      </Modal>
    </Layout>
  );
};
export default AddActivityModal;
